// extracted by mini-css-extract-plugin
module.exports = {"container":"GameDetailSpec_container__adhf4","label":"GameDetailSpec_label__h05I3","values":"GameDetailSpec_values__BJNOQ"};